@if (address) {
  <div class="ms-2 me-auto">
    <div class="fw-bold">
      <strong>{{address.address_type | titlecase}} Address</strong>
    </div>
    @if (address.address_street) {
      <p class="mb-1">{{address.address_street}}</p>
    }
    @if (address.address_street_2) {
      <p class="mb-1">{{address.address_street_2}}</p>
    }
    @if (address.address_city) {
      <p class="mb-1">{{address.address_city}}</p>
    }
    @if (address.address_state) {
      <p class="mb-1">
        {{address.address_state | indianStates}}
        @if (address.address_pin_code) {
          <span class="">- {{address.address_pin_code}}</span>
        }
      </p>
    }
  </div>
} @else {
  <span class="ms-2 me-auto text-muted">
    no address available
  </span>
}

